var isSubs = true
$(document).ready(function () { 
    if($("li[data-index]")[0]){
$("li[data-index]").each(function (index, element) {
  $(element).click(function (e) {
    setTimeout(function () {

      if( $("#termsCheckbox")[0]){
        $("#terms")[0].checked = false
        $("#termsCheckbox").show();
        dynamicButtons();
      }
      
      if ($(".paywhirl-plan-selector-group.paywhirl-group-available").length > 1) {

                let currentTarget = e.target;
        let currentOption = currentTarget;
        if(!currentTarget.classList.contains("nt-swatch")){
          currentOption = currentTarget.closest(".nt-swatch");
        }

        let currentOptionClasses = currentOption.getAttribute("class");

        if(currentOptionClasses.includes("one-time-purchase")) {

           $(".paywhirl-plan-selector.product-form__fieldset").hide();
           $(".paywhirl-plan-selector-group.paywhirl-group-available")[1].style.display = "none";
          if($(".paywhirl-plan-selector-group.paywhirl-group-available > label > span")){
             $(".paywhirl-plan-selector-group.paywhirl-group-available > label > span")[0].click();
          }

           $("#shopify_quantity").show();
           $("#terms")[0].checked = true;
           $("#termsCheckbox").hide();
         
        } else {

          $(".paywhirl-plan-selector-group.paywhirl-group-available")[1].style.display = "block";
           $(".paywhirl-plan-selector.product-form__fieldset").show()
        $(".paywhirl-plan-selector-group.paywhirl-group-available")[0].style = "display:none;"
        $(".paywhirl-plan-selector-group.paywhirl-group-available > label > span")[1].click();
           $("#shopify_quantity").hide();
            $("#termsCheckbox").show();
        }


      } else {
        if($(".paywhirl-plan-selector-group.paywhirl-group-available > label > span")[0]){
          $(".paywhirl-plan-selector-group.paywhirl-group-available > label > span")[0].click()
        }
         if(!$('[data-show-purchase-options]').length) {
         $(".paywhirl-plan-selector.product-form__fieldset").hide();
         }
        if( $("#termsCheckbox")[0] && isSubs){

          if(!$('[data-show-purchase-options]').length) {
             $("#terms")[0].checked = true;
             $("#termsCheckbox").hide();
          }

           dynamicButtons();
        }
        
       
      }
    }, 100);
  });
});
       $("li[data-index]")[0].click() 
    }

    
  if( $("#termsCheckbox")[0]){ 

    $("#terms")[0].addEventListener('change', (event) => {dynamicButtons(); });

    $("#shopify_add_to_cart").click(function (e) {
      if ($("#terms")[0].checked) {

        return true
      } else {
        $("#cart-form")[0].reportValidity()
        return false
      }

    });

  } 

});

function dynamicButtonEvents(value) {
    if($("[data-testid=Checkout-button]").length) {
    $("[data-testid=Checkout-button]").css('pointer-events', value);
  }

  if($("[data-testid=upstream-button]").length) {
    $("[data-testid=upstream-button]").css('pointer-events', value);
  }

  if($("[data-testid=sheet-open-button]").length) {
    $("[data-testid=sheet-open-button]").css('pointer-events', value);
  }
  
}

function updateDynamicButtonEvent(dynamicButton) {
  if(typeof $("#terms")[0] == "undefined" || ($("#terms")[0].checked )){

    $(dynamicButton).css('pointer-events', 'all');

  }else{

    $(dynamicButton).css('pointer-events', 'none');

  }
}

function waitForElement(selector, callback) {
  const interval = setInterval(function() {
    const element = document.querySelector(selector);

    if (element) {
      clearInterval(interval)
      callback(element)
    }
  }, 250)
}

function dynamicButtons() {

  waitForElement('[data-testid=Checkout-button]', function(dynamicButton) {updateDynamicButtonEvent(dynamicButton); });
  waitForElement('[data-testid=upstream-button]', function(dynamicButton) {updateDynamicButtonEvent(dynamicButton);});
  waitForElement('[data-testid=sheet-open-button]', function(dynamicButton) { updateDynamicButtonEvent(dynamicButton);});


}
// Check for loading of dynamic checkout button
(function() {
 
  dynamicButtons();

})();


